import * as React from "react";
import type { SVGProps } from "react";
import { Ref, forwardRef } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgHeart = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    width="1em"
    height="1em"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="#5B6770"
      fillRule="evenodd"
      d="M7.706 4.05a4.798 4.798 0 0 0-3.855 8.21l.007.007 8.152 8.074 8.152-8.074c.025-.024.05-.048.077-.07a4.798 4.798 0 1 0-7.27-6.232 1.2 1.2 0 0 1-1.922-.006 4.798 4.798 0 0 0-3.341-1.908Zm14.061 10.004-8.913 8.827a1.2 1.2 0 0 1-1.688 0l-8.992-8.906a7.197 7.197 0 0 1 9.84-10.5 7.199 7.199 0 0 1 9.532-.04 7.196 7.196 0 0 1 .3 10.547 1.228 1.228 0 0 1-.079.072Z"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgHeart);
export default ForwardRef;
